import { render, staticRenderFns } from "./industries.vue?vue&type=template&id=494d0d68&scoped=true&"
import script from "./industries.vue?vue&type=script&lang=js&"
export * from "./industries.vue?vue&type=script&lang=js&"
import style0 from "./industries.vue?vue&type=style&index=0&id=494d0d68&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494d0d68",
  null
  
)

export default component.exports